import { useContext } from "react";
import { StoreContext } from "../../../store/RootStore";
import { observer } from "mobx-react";
import withRouter from "../../../withRouter";
import config from "../../../config";
import { shouldShowComponent } from "../../../utils/componentVisibility";
import { Form, Input } from "antd";

const VehicleTankTabFormFields = (props) => {
  const shouldShow = shouldShowComponent(
    config.project,
    "VehicleTankTabFormFields"
  );

  const storeContext = useContext(StoreContext); // Use the context here

  if (!shouldShow) {
    return null; // Do not render if the condition is not met
  }

  return (
    <>
      <Form.Item
        className="uploadCompany"
        name="region"
        label={storeContext.translate("_REGION_")}
      >
        <Input />
      </Form.Item>

      <Form.Item
        className="uploadCompany"
        name="branch"
        label={storeContext.translate("_BRANCH_")}
      >
        <Input />
      </Form.Item>

      {/* <Form.Item
          className="uploadCompany"
          name="location"
          label={storeContext.translate("_LOCATION_")}
        >
          <Input />
        </Form.Item> */}
      <Form.Item
        className="uploadCompany"
        name="department"
        label={storeContext.translate("_DEPARTMENT_")}
      >
        <Input />
      </Form.Item>

      <Form.Item
        className="uploadCompany"
        name="ownership"
        label={storeContext.translate("_OWNERSHIP_")}
      >
        <Input />
      </Form.Item>
    </>
  );
};

VehicleTankTabFormFields.contextType = StoreContext;
export default observer(withRouter(VehicleTankTabFormFields));
